import Noun from '../core/Noun';

class MetaAction extends Noun {
  constructor(args = {}) {
    super(args);
  }

  id() {
    return this.attr('name');
  }



  // merge() handled automatically
}

export default MetaAction;
